import React from 'react'
import Moment from 'react-moment'
import styled from '@emotion/styled'
import { Button } from 'semantic-ui-react'
import { IconButton, Tooltip } from '@material-ui/core'
import { Delete, AddToPhotos, Edit, Refresh } from '@material-ui/icons'
import { getOptionTitle, numberFormat } from '../helper'

const budgetTypeOptions = [
  { value: 'BT01', text: 'งบประมาณหน่วยงาน(OPEX)' },
  { value: 'BT02', text: 'งบประมาณหน่วยงาน(OPEX) - ค่ารับรอง' },
  { value: 'BT03', text: 'งบประมาณด้านการตลาด' },
  { value: 'BT04', text: 'งบประมาณโครงการ Internal Order' },
  { value: 'BT05', text: 'งบประมาณโครงการ Real Estate' },
  { value: 'BT06', text: 'งบประมาณโครงการ WBS Type C' },
  { value: 'BT07', text: 'งบประมาณโครงการ WBS Type E,P' },
  { value: 'BT08', text: 'งบประมาณโครงการ WBS Type W' },
  { value: 'BT09', text: 'งบประมาณซื้อทรัพย์สิน' },
  { value: 'BT11', text: 'Asset Dummy' },
  { value: 'BT12', text: 'No Budget' },
]

export const getBudgetTypeOptions = (listType) => {
  return budgetTypeOptions.filter(bt => listType.find(t => t === bt.value) !== undefined)
}

// PR ITEMS
const blankItem = {
  itemName: '', 
  quantity: 0, 
  unit: '', 
  unitPrice: 0, 
  totalAmount: 0,
}

const checkVisibleColumn = (items, fieldName) => {
  if (fieldName === 'materialNo') {
    let itemWithMaterial = items.filter(i => i.materialNo !== '')
    return !(itemWithMaterial && itemWithMaterial.length === 0)
  }

  if (fieldName === 'costCenter') {
    let itemByAccountAssignment = items.filter(
      i => i.accountAssignment === 'K' || 
           i.accountAssignment === 'Z')
    return !(itemByAccountAssignment && itemByAccountAssignment.length === 0)
  }

  if (fieldName === 'glAccountCode') {
    let itemByAccountAssignment = items.filter(
      i => i.accountAssignment !== 'A' && 
           i.accountAssignment !== 'Y' && 
           i.accountAssignment !== 'C' && 
           i.accountAssignment !== '' && 
           i.accountAssignment !== null) || []
    return (itemByAccountAssignment.length !== 0)
  }

  if (fieldName === 'wbsElement') {
    let itemByAccountAssignment = items.filter(
      i => i.accountAssignment === 'A' || 
           i.accountAssignment === 'P' || 
           i.accountAssignment === 'R' || 
           i.accountAssignment === 'W')
    return !(itemByAccountAssignment && itemByAccountAssignment.length === 0)
  }

  if (fieldName === 'asset') {
    let itemByAccountAssignment = items.filter(
      i => i.accountAssignment === 'A' || 
           i.accountAssignment === 'Y')
    return !(itemByAccountAssignment && itemByAccountAssignment.length === 0)
  }

  if (fieldName === 'orderNo') {
    let itemByAccountAssignment = items.filter(
      i => i.accountAssignment === 'F' || 
           i.accountAssignment === 'Z' ||
           i.accountAssignment === 'A')
    return !(itemByAccountAssignment && itemByAccountAssignment.length === 0)
  }
  
  if (fieldName === 'salesOrder' || fieldName === 'salesOrderItemNo') {
    let itemByAccountAssignment = items.filter(i => i.accountAssignment === 'C')
    return !(itemByAccountAssignment && itemByAccountAssignment.length === 0)
  }

  if (fieldName === 'profitCenter') {
    let itemByAccountAssignment = items.filter(
      i => i.accountAssignment === 'X' || 
           i.accountAssignment === 'S')
    return !(itemByAccountAssignment && itemByAccountAssignment.length === 0)
  }
  
  if (fieldName === 'productHierarchyLv2' || fieldName === 'customer') {
    let itemByAccountAssignment = items.filter(i => i.accountAssignment === 'S')
    return !(itemByAccountAssignment && itemByAccountAssignment.length === 0)
  }

  if (fieldName === 'accountAssignment') {
    let itemByAccountAssignment = items.filter(
      i => i.accountAssignment !== '' && 
           i.accountAssignment !== null) || []
    return (itemByAccountAssignment.length !== 0)
  }

  if (fieldName === 'budgetType') {
    let itemByCondition = items.filter(
      i => i.budgetType === '' || 
           i.budgetType === null ||
           i.budgetType === 'BT12') || []
    return itemByCondition.length !== items.length
  }

  return true
}

const WrapTextDiv = styled.div({
  width: '100%',
  whiteSpace: 'normal',
  wordWrap: 'break-word'
})

const columns = (props) => {
  const { 
    withActions, fields, items, change, showPrItemModal, 
    budgetTypeOptions, assetOptions, unitOptions, currencyOptions,
    materialGroupOptions, plantOptions, storageLocationOptions, 
    costCenterOptions, glAccountOptions, onSubmitItem,
    purchasingGroupOptions, editPrItem, onDeletePRItem,
    orderOptions, purchasingOrgOptions, profitCenterOptions, wbsOptions, onDeletePRItemById } = props

  return [
    {
      Header: 'Actions',
      accessor: '',
      show: withActions,
      Cell: row => (
        <div className='actionsContent'>
          {!fields.get(row.index).deleted&&
          <Tooltip title='Edit item'>
            <IconButton 
              onClick={() => 
                showPrItemModal(true, false, {...row.original}, editPrItem(row.index, change))
              }>
              <Edit />
            </IconButton>
          </Tooltip>}
          {!fields.get(row.index).deleted&&
          <Tooltip title='Clone this item to new item'>
            <IconButton onClick={() => {
              showPrItemModal(true, true, {...row.original,id:0}, onSubmitItem(fields, change))}
            }><AddToPhotos /></IconButton>
          </Tooltip>}
          <Tooltip title='Remove item'>
            <IconButton onClick={() => {
              if (props.isEditPR && row.original.id !== 0) {
                onDeletePRItemById()
                change(`items[${row.index}].deleted`,!fields.get(row.index).deleted)
              }else if (props.isEditPR){
                if(onDeletePRItem) {
                  onDeletePRItem(fields, change,row.index)
                }
              } else {
                fields.remove(row.index)
                if (items.length === 1) {
                  change('vatRate', 7)
                }
              }
            }}>
              {
                fields.get(row.index).deleted?
                <Refresh style={{color:'#fff'}}/>
                :
                <Delete />
              }
            </IconButton>
          </Tooltip>
        </div>
      )
    }, {
      Header: 'No',
      accessor: 'lineNo',
      width: 40,
      Cell: row => (<span className='alignCenter'>{row.value}</span>)
    }, {
      Header: 'Material No',
      accessor: 'materialNo',
      show: checkVisibleColumn(items, 'materialNo'),
    }, {
      Header: 'Item Name',
      width: 240,
      accessor: 'itemName',
      Cell: row => (<WrapTextDiv>{row.value}</WrapTextDiv>)
    }, {
      Header: 'Item Description',
      width: 200,
      accessor: 'itemDescription',
      Cell: row => (<Tooltip title={row.value}><div>{row.value}</div></Tooltip>)
    }, {
      Header: 'Quantity',
      accessor: 'quantity',
      width: 80,
      className:'right',
      Cell: row => (<div className='alignRight'>{numberFormat(row.value, false, 3)}</div>)
    }, {
      Header: 'Unit',
      accessor: 'unit',
      width: 80,
      Cell: row => (getOptionTitle(unitOptions, row.value))
    }, {
      Header: 'Unit Price (Ex.VAT)',
      accessor: 'unitPrice',
      className:'right',
      width: 100,
      Cell: row => (<div className='alignRight'>{numberFormat(row.value)}</div>)
    }, {
      Header: 'Currency',
      accessor: 'currency',
      width: 80,
      Cell: row => (getOptionTitle(currencyOptions, row.value))
    }, {
      Header: 'Total Amount (Ex.VAT)',
      accessor: 'totalAmount',
      className:'right',
      width: 100,
      Cell: row => (<div className='alignRight'>{numberFormat(row.value)}</div>)
    }, {
      Header: 'Budget Type',
      accessor: 'budgetType',
      show: checkVisibleColumn(items, 'budgetType'),
      Cell: row => (getOptionTitle(budgetTypeOptions, row.value)),
    }, {
      Header: 'Cost Center',
      accessor: 'costCenter',
      show: checkVisibleColumn(items, 'costCenter'),
      Cell: row => (getOptionTitle(costCenterOptions, row.value)),
    }, {
      Header: 'WBS',
      accessor: 'wbsElement',
      show: checkVisibleColumn(items, 'wbsElement'),
      Cell: row => (getOptionTitle(wbsOptions, row.value)),
    }, {
      Header: 'Order No',
      accessor: 'orderNo',
      show: checkVisibleColumn(items, 'orderNo'),
      Cell: row => (getOptionTitle(orderOptions, row.value)),
    }, {
      Header: 'GL Account',
      accessor: 'glAccountCode',
      show: checkVisibleColumn(items, 'glAccountCode'),
      Cell: row => (getOptionTitle(glAccountOptions, row.value)),
    }, {
      Header: 'Asset',
      accessor: 'asset',
      show: checkVisibleColumn(items, 'asset'),
      Cell: row => (getOptionTitle(assetOptions, row.value)),
    }, {
      Header: 'Sales Order',
      accessor: 'salesOrder',
      show: checkVisibleColumn(items, 'salesOrder'),
    }, {
      Header: 'Sales Order Item No',
      accessor: 'salesOrderItemNo',
      show: checkVisibleColumn(items, 'salesOrderItemNo'),
    }, {
      Header: 'Profit Center',
      accessor: 'profitCenter',
      show: checkVisibleColumn(items, 'profitCenter'),
      Cell: row => (getOptionTitle(profitCenterOptions, row.value)),
    }, {
      Header: 'Product Hierarchy Level 2',
      accessor: 'productHierarchyLv2',
      show: checkVisibleColumn(items, 'productHierarchyLv2'),
    }, {
      Header: 'Customer',
      accessor: 'customer',
      show: checkVisibleColumn(items, 'customer'),
    }, { 
      Header: 'Account Assignment',
      accessor: 'accountAssignment',
      width: 72,
      className: 'center',
      show: checkVisibleColumn(items, 'accountAssignment'),
    }, {
      Header: 'Start Date',
      accessor: 'startDate',
      Cell: row => (<Moment format='DD MMM YYYY'>{row.value}</Moment>)
    }, {
      Header: 'Delivery Date / Finish Date',
      accessor: 'deliveryDate',
      Cell: row => (<Moment format='DD MMM YYYY'>{row.value}</Moment>)
    }, {
      Header: 'Plant',
      accessor: 'plant',
      Cell: row => (getOptionTitle(plantOptions, row.value))
    }, {
      Header: 'Storage Location',
      accessor: 'storageLocation',
      Cell: row => (getOptionTitle(storageLocationOptions.filter(s => s.plantCode === row.original.plant), row.value))
    }, {
      Header: 'Purchasing Group',
      accessor: 'purchasingGroup',
      Cell: row => (getOptionTitle(purchasingGroupOptions, row.value))
    }, {
      Header: 'Purchasing Org',
      accessor: 'purchasingOrg',
      Cell: row => (getOptionTitle(purchasingOrgOptions, row.value))
    }, {
      Header: 'Material Group',
      accessor: 'materialGroup',
      Cell: row => (getOptionTitle(materialGroupOptions, row.value))
    },
  ]
}

export const itemColumns = (props) => {
  const { 
    withActions, fields, showPrItemModal, defaultCurrency,
    costCenterByRequester, onSubmitItem, menuSubCategory, } = props

  if (withActions) {
    return [
      {
        Header: 
          withActions ?
          <div style={{ display: 'flex', flex: 1, width: '100%' }}>
            <Button 
              basic
              type='button'
              content='Add New Item' 
              color='blue' 
              icon='add' 
              onClick={() => 
                showPrItemModal(true, true, { 
                  ...blankItem,
                  currency: defaultCurrency || 'THB',
                  menuSubCategory, 
                  costCenter: costCenterByRequester }, onSubmitItem(fields,props.change))}
              labelPosition='right'
            />
          </div> : null,
        columns: columns(props)
      }
    ]
  } else {
    return columns(props)
  }
}

// BUDGET 
export const costCenterColumn = [
  {
    Header: 'Cost Center',
    accessor: 'code',
  },
  {
    Header: 'Cost Center Name',
    accessor: 'description',
  },
  {
    Header: 'GL Account',
    accessor: 'code2',
  },
  {
    Header: 'GL Description',
    accessor: 'description2',
  },
  {
    Header: 'Budget',
    accessor: 'plan',
    className: 'right',
    Cell: row => (
      row.value === null ? 
        <div style={{ color: 'red', fontWeight: 'bold' }}>Budget not found</div> : 
        <div className='alignRight'>{numberFormat(row.value, true)}</div>
    ),
  },
  {
    Header: 'Assigned',
    accessor: 'assigned',
    className: 'right',
    Cell: row => (<div className='alignRight'>{numberFormat(row.value, true)}</div>),
  },
  {
    Header: 'Available',
    accessor: 'available',
    className: 'right',
    Cell: row => (<div className='alignRight'>{numberFormat(row.value, true)}</div>),
  },
  {
    Header: 'Currency',
    accessor: 'currencyCode',
    width: 80,
    className: 'center',
    Cell: row => (<div className='alignCenter'>{row.value}</div>),
  },
]

export const wbsColumn = [
  {
    Header: 'Work Breakdown Structure (WBS)',
    accessor: 'code',
  },
  {
    Header: 'Description',
    accessor: 'description',
  },
  {
    Header: 'Budget',
    accessor: 'plan',
    className: 'right',
    Cell: row => (
      <div className='alignRight'>{numberFormat((row.value || 0), true)}</div>
      // row.value === null ? 
      //   <div style={{ color: 'red', fontWeight: 'bold' }}>Budget not found</div> : 
      //   <div className='alignRight'>{numberFormat(row.value, true)}</div>
    ),
  },
  {
    Header: 'Assigned',
    accessor: 'assigned',
    className: 'right',
    Cell: row => (<div className='alignRight'>{numberFormat(row.value, true)}</div>),
  },
  {
    Header: 'Available',
    accessor: 'available',
    className: 'right',
    Cell: row => (<div className='alignRight'>{numberFormat(row.value, true)}</div>),
  },
  {
    Header: 'Currency',
    accessor: 'currencyCode',
    width: 80,
    className: 'center',
    Cell: row => (<div className='alignCenter'>{row.value}</div>),
  },
]

export const internalOrderColumn = [
  {
    Header: 'Internal Order',
    accessor: 'code',
  },
  {
    Header: 'Description',
    accessor: 'description',
  },
  {
    Header: 'GL Account',
    accessor: 'code2',
  },
  {
    Header: 'GL Description',
    accessor: 'description2',
  },
  {
    Header: 'Plan',
    accessor: 'plan',
    className: 'right',
    Cell: row => (
      row.value === null || row.value === 0 ? 
        <div style={{ color: 'red', fontWeight: 'bold' }}>Budget not found</div> : 
        <div className='alignRight'>{numberFormat(row.value, true)}</div>
    ),
  },
  {
    Header: 'Assigned',
    accessor: 'assigned',
    className: 'right',
    Cell: row => (<div className='alignRight'>{numberFormat(row.value, true)}</div>),
  },
  {
    Header: 'Available',
    accessor: 'available',
    className: 'right',
    Cell: row => (<div className='alignRight'>{numberFormat(row.value, true)}</div>),
  },
  {
    Header: 'Currency',
    accessor: 'currencyCode',
    width: 80,
    className: 'center',
    Cell: row => (<div className='alignCenter'>{row.value}</div>),
  },
]

export const migrationColumn = [
  {
    Header: 'Code',
    accessor: 'code',
  },
  {
    Header: 'Description',
    accessor: 'description',
  },
  {
    Header: 'Code 2',
    accessor: 'code2',
  },
  {
    Header: 'Description 2',
    accessor: 'description2',
  },
  {
    Header: 'Plan',
    accessor: 'plan',
    className: 'right',
    Cell: row => (
      row.value === null || row.value === 0 ? 
        <div style={{ color: 'red', fontWeight: 'bold' }}>Budget not found</div> : 
        <div className='alignRight'>{numberFormat(row.value, true)}</div>
    ),
  },
  {
    Header: 'Assigned',
    accessor: 'assigned',
    className: 'right',
    Cell: row => (<div className='alignRight'>{numberFormat(row.value, true)}</div>),
  },
  {
    Header: 'Available',
    accessor: 'available',
    className: 'right',
    Cell: row => (<div className='alignRight'>{numberFormat(row.value, true)}</div>),
  },
  {
    Header: 'Currency',
    accessor: 'currencyCode',
    width: 80,
    className: 'center',
    Cell: row => (<div className='alignCenter'>{row.value}</div>),
  },
]
